import { combineReducers } from "redux"
import { transactionReducer } from "./transactions"
import { kolQueryReducer } from "./kolQuery"
import { kolFiltersReducer } from "./kolFilters"

const reducers = combineReducers({
  transactions: transactionReducer,
  kolQuery: kolQueryReducer,
  kolFilters: kolFiltersReducer,
})

export default reducers
